module.exports = __webpack_public_path__ + "static/media/visitation.db133758.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/visitation.svg
// module id = 315
// module chunks = 31